import Image from "next/image";

import PlayButton from "@/assets/img/play.svg";
import { CardMedia, Fade, Stack } from "@mui/material";

import { styles } from "./styles";
import { AccordionCustomThumbProps } from "./types";

export const AccordionCustomThumb: React.FC<AccordionCustomThumbProps> = ({ mediaType, mediaSrc }) => {
  return (
    <Fade in={true} timeout={1000}>
      <Stack position="relative" justifyContent="center" alignItems="center">
        <CardMedia src={mediaSrc} component={mediaType === "video" ? "video" : "img"} controls={false} css={styles.media} />

        {mediaType === "video" ? <Image src={PlayButton} alt="" css={styles.playbuttom_image} /> : null}
      </Stack>
    </Fade>
  );
};
